import { render, staticRenderFns } from "./SiteClassifiedsConfig.vue?vue&type=template&id=319f4faa&"
import script from "./SiteClassifiedsConfig.vue?vue&type=script&lang=js&"
export * from "./SiteClassifiedsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports